import { render } from "./MerceariaPage.vue?vue&type=template&id=4b98fe1f&scoped=true"
import script from "./MerceariaPage.vue?vue&type=script&lang=js"
export * from "./MerceariaPage.vue?vue&type=script&lang=js"

import "./MerceariaPage.vue?vue&type=style&index=0&id=4b98fe1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b98fe1f"]])

export default __exports__